import React from 'react'
import { commas, useInterval, useObserver } from '../../utils';

export const Stats = () => {
  const [containerRef, isVisible] = useObserver({
    threshold: 0.9
  });
  return <div className="stats" ref={containerRef}>
    <Stat qty={30000} step={283} isVisible={isVisible} caption={<>photographers<br/>helped</>}/>
    <Stat qty={1500}  step={14} isVisible={isVisible} caption={<>hire-able items<br/>stocked</>}/>
    <Stat qty={75000} step={713} isVisible={isVisible} caption={<>orders<br/>accepted</>}/>
  </div>
}

export const Stat = ({qty, step, caption, isVisible}) => {
  const [count, setCount] = React.useState(0);
  const [counting, startCounting] = React.useState(isVisible);
  const [stopped, stopCounting] = React.useState(false);

  useInterval(
    () => {
      if (isVisible && count < qty) {
        const newCount = count + step;
        if (newCount >= qty) {
          setCount(qty);
          stopCounting(true);
        }
        else {
          setCount(newCount);
        }
      }
    },
    count < qty ? 20 : null
  )
  if (! counting && isVisible) {
    startCounting(true);
  }
  return <div className="stat">
    <div className="qty">{commas(count)}{(stopped) ? '+' : null}</div>
    <div className="caption">{caption}</div>
  </div>
}

export default Stats